<template>
  <div :class="pageClass">
    <el-tabs tab-position="top" style="height: 100%" @tab-click="changeTab" v-model="label">
      <el-tab-pane label="未交卷" name="uncomplete">
        <evaluation-search
          @remoteMethod="uncompleteRemoteMethod"
          @selectType="uncompleteSelectType"
          @searchEvaluationQuestion="uncompleteSearchEvaluation"
          @selectSubject="uncompleteSelectSubject"
          @selectNavigation="uncompleteSelectNavigation"
          :data-list="uncomplete.searchDataList"
          :navigation-arr="uncomplete.navigationArr"
        ></evaluation-search>
        <uncomplete-tabel 
          :tabel-data="uncomplete"
          @changeIndexs="currentUncomplete"
          v-loading="uncompleteLoading"
        >
        </uncomplete-tabel>
      </el-tab-pane>
      <el-tab-pane label="未自评" name="no_comment">
        <evaluation-search
          @remoteMethod="noCommentRemoteMethod"
          @selectType="noCommentSelectType"
          @selectSubject="noCommentSelectSubject"
          @searchEvaluationQuestion="noCommentSearchEvaluation"
          @selectNavigation="noCommentSelectNavigation"
          :data-list="noComment.searchDataList"
          :navigation-arr="noComment.navigationArr"
        ></evaluation-search>
        <nocomment-tabel
          :tabel-data="noComment"
          @changeIndexs="currentNoComment"
          v-loading="noCommentLoading"
        >
        </nocomment-tabel>
      </el-tab-pane>
      <el-tab-pane label="已交卷" name="evaluated">
        <evaluation-search
          @remoteMethod="evaluatedRemoteMethod"
          @selectType="evaluatedSelectType"
          @selectSubject="evaluatedSelectSubject"
          @searchEvaluationQuestion="evaluatedSearchEvaluation"
          @selectNavigation="evaluatedSelectNavigation"
          :data-list="evaluated.searchDataList"
          :navigation-arr="evaluated.navigationArr"
        ></evaluation-search>
        <evaluated-tabel
          :tabel-data="evaluated"
          @changeIndexs="currentEvaluated"
          v-loading="evaluatedLoading"
        >
        </evaluated-tabel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import evaluationSearch from './search.vue'
// import evaluationTabel from './tabel.vue'
import uncompleteTabel from './tabel_uncomplete.vue'
import nocommentTabel from './tabel_noComment.vue'
import evaluatedTabel from './tabel_evaluated.vue'

export default {
  data() {
    return {
      pageClass: 'evaluation',
      columns: [],
      // 未完成
      uncomplete: {
        params: {
          userId: null,
          typeCode: '',
          subjectId: null,
          pageIndex: 1,
          pageSize: 10,
          pname: '',
          navigationId: null
        },
        totalCount: 0,
        tabelData: [],
        searchDataList: [],
        showSelect: false,
        navigationArr: []
      },
      // 未评
      noComment: {
        params: {
          userId: null,
          typeCode: '',
          subjectId: null,
          pageIndex: 1,
          pageSize: 10,
          pname: '',
          navigationId: null
        },
        totalCount: 0,
        tabelData: [],
        searchDataList: [],
        showSelect: false,
        navigationArr: []
      },
      // 已评
      evaluated: {
        params: {
          userId: null,
          typeCode: '',
          subjectId: null,
          pageIndex: 1,
          pageSize: 10,
          pname: '',
          navigationId: null
        },
        tabelData: [],
        totalCount: 0,
        searchDataList: [],
        label: 'uncomplete',
        showSelect: false,
        navigationArr: []
      },

      uncompleteLoading: false,
      noCommentLoading: false,
      evaluatedLoading: false
    } 
  },
  components: {
    evaluationSearch,
    // evaluationTabel,
    uncompleteTabel,
    nocommentTabel,
    evaluatedTabel
  },
  methods: {
    // 未完成
    // 选择测评模式
    uncompleteSelectType(val) {
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.uncomplete.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (val == 11) { // 基础夯实
          this.getErlunNavigation(this.uncomplete.params.subjectId, 'TK', 1)
        } else if (val == 21) { // 21 专题强化
          this.getErlunNavigation(this.uncomplete.params.subjectId, 'GKEL', 1)
        }
      } else { // 老高考
        if(val == 11){
          this.getErlunNavigation(this.uncomplete.params.subjectId, 'XK', 1)
        } else if (val == 21) {
          this.getErlunNavigation(this.uncomplete.params.subjectId, 'GKEL', 1)
        }
      }

      this.uncomplete.params.typeCode = val
      this.getUncomplete()
    },
    uncompleteSelectNavigation(val) {
      this.uncomplete.params.navigationId = +val
      this.getUncomplete()
    },
    // 选择课目
    uncompleteSelectSubject(val) {
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.uncomplete.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (this.uncomplete.params.typeCode == 11) { // 基础夯实
          this.getErlunNavigation(+val, 'TK', 1)
        } else if (this.uncomplete.params.typeCode == 21) { // 21 专题强化
          this.getErlunNavigation(+val, 'GKEL', 1)
        }
      } else { // 老高考
        if(this.uncomplete.params.typeCode == 11){
          this.getErlunNavigation(+val, 'XK', 1)
        } else if (this.uncomplete.params.typeCode == 21) {
          this.getErlunNavigation(+val, 'GKEL', 1)
        }
      }
      this.uncomplete.params.subjectId = +val
      this.getUncomplete()
    },
    // 关键字
    uncompleteRemoteMethod(val) {
      this.uncomplete.params.pname = val
      this.$HTTP.executePost(this.$APIS.GET_UNCOMPLETE, this.uncomplete.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.uncomplete
            that.searchDataList = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
          } else {
            this.$message.error(res.msg);
          }
      })
    },
    currentUncomplete(val) {
      this.uncomplete.params.pageIndex = +val
      this.getUncomplete()
    },
    uncompleteSearchEvaluation(val) {
       this.uncomplete.params.pname = val
       this.getUncomplete()
    },

    // 未评
    // 选择测评模式
    noCommentSelectType(val) {
      this.noComment.params.typeCode = val
      this.getNoComment()

      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.noComment.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (val == 11) { // 基础夯实
          this.getErlunNavigation(this.noComment.params.subjectId, 'TK', 2)
        } else if (val == 21) { // 21 专题强化
          this.getErlunNavigation(this.noComment.params.subjectId, 'GKEL', 2)
        }
      } else { // 老高考
        if(val == 11){
          this.getErlunNavigation(this.noComment.params.subjectId, 'XK', 2)
        } else if (val == 21) {
          this.getErlunNavigation(this.noComment.params.subjectId, 'GKEL', 2)
        }
      }
    },
    noCommentSelectSubject(val) {
      this.noComment.params.subjectId = +val
      this.getNoComment()
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.noComment.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (this.noComment.params.typeCode == 11) { // 基础夯实
          this.getErlunNavigation(+val, 'TK', 2)
        } else if (this.noComment.params.typeCode == 21) { // 21 专题强化
          this.getErlunNavigation(+val, 'GKEL', 2)
        }
      } else { // 老高考
        if(this.noComment.params.typeCode == 11){
          this.getErlunNavigation(+val, 'XK', 2)
        } else if (this.noComment.params.typeCode == 21) {
          this.getErlunNavigation(+val, 'GKEL', 2)
        }
      }
    },
    noCommentSelectNavigation(val) {
      this.noComment.params.navigationId = +val
      this.getUncomplete()
    },
    noCommentRemoteMethod(val) {
      this.noComment.params.pname = val
      this.$HTTP.executePost(this.$APIS.GET_UN_AUDIT, this.noComment.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.noComment
            that.searchDataList = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
          } else {
            this.$message.error(res.msg);
          }
      })
    },
    currentNoComment(val) {
      this.noComment.params.pageIndex = +val
      this.getNoComment()
    },
    noCommentSearchEvaluation(val) {
       this.noComment.params.pname = val
       this.getNoComment()
    },
    
    // 已评
    evaluatedSelectType(val) {
      this.evaluated.params.typeCode = val
      this.getevaluated()
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.evaluated.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (val == 11) { // 基础夯实
          this.getErlunNavigation(this.evaluated.params.subjectId, 'TK', 3)
        } else if (val == 21) { // 21 专题强化
          this.getErlunNavigation(this.evaluated.params.subjectId, 'GKEL', 3)
        }
      } else { // 老高考
        if(val == 11){
          this.getErlunNavigation(this.evaluated.params.subjectId, 'XK', 3)
        } else if (val == 21) {
          this.getErlunNavigation(this.evaluated.params.subjectId, 'GKEL', 3)
        }
      }
    },
    evaluatedSelectSubject(val) {
      this.evaluated.params.subjectId = +val
      this.getevaluated()
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);
      this.evaluated.navigationArr = []
      if (user.gkType == 1) { // 新高考
        if (this.evaluated.params.typeCode == 11) { // 基础夯实
          this.getErlunNavigation(+val, 'TK', 3)
        } else if (this.evaluated.params.typeCode == 21) { // 21 专题强化
          this.getErlunNavigation(+val, 'GKEL', 3)
        }
      } else { // 老高考
        if(this.evaluated.params.typeCode == 11){
          this.getErlunNavigation(+val, 'XK', 3)
        } else if (this.evaluated.params.typeCode == 21) {
          this.getErlunNavigation(+val, 'GKEL', 3)
        }
      }
    },
    evaluatedSelectNavigation(val) {
      this.evaluated.params.navigationId = +val
      this.getevaluated()
    },
    evaluatedRemoteMethod(val) {
      this.evaluated.params.pname = val
      this.$HTTP.executePost(this.$APIS.GET_AUDIT, this.evaluated.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.evaluated
            that.searchDataList = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
          } else {
            this.$message.error(res.msg);
          }
      })
    },
    currentEvaluated(val) {
      this.evaluated.params.pageIndex = +val
      this.getevaluated()
    },
    evaluatedSearchEvaluation(val) {
      this.evaluated.params.pname = val
       this.getevaluated()
    },

    // 已评接口
    getevaluated() {
      this.evaluatedLoading = true
      this.$HTTP.executePost(this.$APIS.GET_AUDIT, this.evaluated.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.evaluated
            that.tabelData = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
            this.evaluatedLoading = false
          } else {
            this.evaluatedLoading = false
            this.$message.error(res.msg);
          }
      })
    },
    // 未评接口
    getNoComment() {
      this.noCommentLoading = true
      this.$HTTP.executePost(this.$APIS.GET_UN_AUDIT, this.noComment.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.noComment
            that.tabelData = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
            this.noCommentLoading = false
          } else {
            this.noCommentLoading = false
            this.$message.error(res.msg);
          }
      })
    },
    // 未完成
    getUncomplete() {
      this.uncompleteLoading = true
      this.$HTTP.executePost(this.$APIS.GET_UNCOMPLETE, this.uncomplete.params, this).then(res => {
          let code = res.code;
          if (!code) {
            const that = this.uncomplete
            that.tabelData = res.data.list
            that.totalCount = res.data.total
            that.params.pageIndex = res.data.pageIndex
            that.params.pageSize = res.data.pageSize
            this.uncompleteLoading = false
          } else {
            this.uncompleteLoading = false
            this.$message.error(res.msg);
          }
      })
    },
    // GET_AUDIT : "/test/get-test-audit", //根据用户id查询已评列表
    changeTab(val) {
      if (+val.index == 1) {
        try {
          let data = {
            code: 7,
            data: 'no_comment'
          }
          let d = JSON.stringify(data)
          cefJS.sendmsg(d);
        } catch (error) {
          console.log(error)
        }
      } else if (+val.index == 2) {
        try {
          let data = {
            code: 7,
            data: 'evaluated'
          }
          let d = JSON.stringify(data)
          cefJS.sendmsg(d);
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          let data = {
            code: 7,
            data: 'uncomplete'
          }
          let d = JSON.stringify(data)
          cefJS.sendmsg(d);
        } catch (error) {
          console.log(error)
        }
      }
    },
    getErlunNavigation(sid, gkType, type) {
      const navParams = {
        subject_id: sid,
        gk_type: gkType,
        t: new Date().getTime()
      }
      this.$HTTP.executePost(this.$APIS.GET_ERLUN_NAVIGATION, navParams, this).then(res => {
          let code = res.code;
          if (!code) {
            if (type == 1) {
              this.uncomplete.navigationArr = []
              this.uncomplete.navigationArr = res.data
            } else if (type == 2) {
              this.noComment.navigationArr = []
              this.noComment.navigationArr = res.data
            } else if (type == 3) {
              this.evaluated.navigationArr = []
              this.evaluated.navigationArr = res.data
            }
          }
      })
    }

    
  },
  created() {
    let user_json = localStorage.getItem('userinfo');
    const user = JSON.parse(user_json);
    this.uncomplete.params.userId = user.id
    this.noComment.params.userId = user.id
    this.evaluated.params.userId = user.id
    this.getUncomplete()
    this.getNoComment()
    this.getevaluated()

    this.label = this.$route.query.label ? this.$route.query.label : 'uncomplete'
  },
  mounted () {
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
<style scoped lang="stylus">
  .evaluation {
    width: 1520px;
    margin: 0 auto;
    height: 100%;
    /deep/ .el-tabs--border-card {
      background: none;
      border: none;
      box-shadow: none;
    }
    /deep/ .el-tabs {
      width: 100%;
      height: 100%;

      .el-tabs__header {
        background-color: #fff;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .el-tab-pane {
        background-color: #fff;
      }

      .el-tabs__active-bar {
        background-color: #5c307d;
        height: 4px;
        width: 100px;
        padding: 0 50px;
        margin-left: -25px;
      }
      
      .el-tabs__item {
        font-size 18px;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
      }
      .el-tabs__item:last-child {
        padding: 0 80px;
      }
      .el-tabs__item:first-child {
        padding: 0 95px;
      }
      .el-tabs__item:nth-child(2) {
        padding: 0 95px;
      }
      .el-tabs__nav-wrap::after {
        background-color: #ffffff;
      }
      .el-tabs__item.is-active {
        color: #5c307d;
        // border-bottom: 5px solid #5c307d;
      }
      .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
        color: #5c307d;
        // border-bottom: 5px solid #5c307d;
      }
    }

    /deep/ .el-tabs__content {
      padding: 0;
    }
  }
</style>